import React from 'react'

const TextAreaComp = React.forwardRef(({ label, onChange, name, rows, error, className, hoverMessage, minLength, maxLength, ...rest }, ref) => (
    <div className="row mb-1" title={hoverMessage}>
        <label htmlFor={name} className="col-auto col-form-label">
            {label}
        </label>
        <div className="col-auto">
            <textarea
                className={`form-control text dark ${className}`}
                id={name}
                name={name}
                ref={ref}
                rows={rows}
                required
                maxLength={maxLength}
                minLength={minLength}
                {...rest}
                onChange={onChange}
            />
        </div>
        {error && <p className="text-danger mt-2">{error.message}</p>}
    </div>
));


export default TextAreaComp